import { backendApi } from "../dynamicBAseQuery";

export const RecruitersApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        InternalRecruiterList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "InternalRecruiterList",
                params: args
            })
        }),
        recruiterDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: "recruiterDropDown"
            })
        }),
        recruiterJobList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "recruiterJobList",
                body: { ...args }
            })
        }),
        RecruiterClientAssign: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "RecruiterClientAssign",
                body: { ...args }
            })
        }),
        RecruiterClientAssignedList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "RecruiterClientAssignedList",
                body: { ...args }
            })
        }),

        AssignClientStatus: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "AssignClientStatus?",
                params: args
            })
        }),

        ExternalRecruiterList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "ExternalRecruiterList?",
                params: args
            })
        }),

        getRecruiterAssignClients: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: 'getRecruiterAssignClients',
                body: { ...args }
            })
        }),
        addRecruiterSignUp: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'addRecruiterSignUp',
                body: { ...args }
            })
        }),

        unassignMappedClient: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "unassignMappedClient",
                params: args
            })
        }),
        ViewBaPerformance: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "ViewBaPerformance",
                body: { ...args }
            })
        }),
        BaReferralList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "BaReferralList",
                params: args
            })
        }),
        BAOverViewSummary: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "BAOverViewSummary",
                params: args
            })
        }),
        analyzeBAReferralPerformance: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "analyzeBAReferralPerformance",
                body: { ...args }
            })
        }),
        
         BAPerformanceScore: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "BAPerformanceScore",
                params: args
            })
        }),
    
         BAClientSummary: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "BAClientSummary",
                params: args
            })
        }),

    })
})
export const {
    useInternalRecruiterListMutation,
    useRecruiterDropDownQuery,
    useRecruiterJobListMutation,
    useRecruiterClientAssignMutation,
    useRecruiterClientAssignedListMutation,
    useAssignClientStatusMutation,
    useExternalRecruiterListMutation,
    useGetRecruiterAssignClientsMutation,
    useAddRecruiterSignUpMutation,
    useUnassignMappedClientMutation,
    useViewBaPerformanceMutation,
    useBaReferralListMutation,
    useBAOverViewSummaryMutation,
    useAnalyzeBAReferralPerformanceMutation,
    useBAPerformanceScoreMutation,
    useBAClientSummaryMutation
} = RecruitersApi